import { errorNotification, successNotification } from './notificationActions';
import { FETCHING_ERROR } from './types';

export const succeeded = actionName => `${actionName}_SUCCESS`;
export const failed = actionName => `${actionName}_FAILURE`;

const fetchingError = errorMessage => ({
  type: FETCHING_ERROR,
  errorMessage,
});

export const fetchActionFactory = (actionName, fetcher, options={}) => (...args) => async dispatch => {
  const { field = '', successMessage = '' } = options;

  dispatch({
    type: actionName,
  });

  try {
    const data = field
      ? { [field]: await fetcher(...args) }
      : await fetcher(...args);

    dispatch({
      type: succeeded(actionName),
      ...data,
    });
    if (successMessage) {
      dispatch(successNotification(successMessage));
    }
    return;
  } catch (error) {
    dispatch({
      type: failed(actionName),
    });
    if (error.isAuthorizationError) {
      return;
    }
    if (error.isFetchingError) {
      dispatch(fetchingError(error.message));
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchReducerFactory = (resourceNames, resourceInitialState, defaultPayload) => {
  const actionNames = Object.keys(resourceNames);

  const initialState = Object.values(resourceNames).reduce((initialState, resourceName) => {
    const isLoadingResourceName = `isLoading${resourceName}`;
    initialState[isLoadingResourceName] = false;

    return initialState;
  }, resourceInitialState);

  const stateWithDefaultPayload = defaultPayload
    ? { [defaultPayload]: initialState[defaultPayload] }
    : {};

  const actionHandlers = actionNames.reduce((handlers, actionName) => {
    const resourceName = resourceNames[actionName];
    const isLoadingResourceName = `isLoading${resourceName}`;

    handlers[actionName] = state => ({
      ...state,
      ...stateWithDefaultPayload,
      [isLoadingResourceName]: true,
    });

    handlers[succeeded(actionName)] = (state, payload) => ({
      ...state,
      ...payload,
      [isLoadingResourceName]: false,
    });

    handlers[failed(actionName)] = state => ({
      ...state,
      ...stateWithDefaultPayload,
      [isLoadingResourceName]: false,
    });

    return handlers;
  }, {});

  return (state = initialState, { type, ...payload } = {}) => {
    if (actionHandlers[type]) {
      return actionHandlers[type](state, payload);
    }

    return state;
  };
};
